import styled from "styled-components";
import { colorFromTheme } from "./Title";

export const StyledMain = styled.div`
    background-color: ${({ theme }) => theme.mode === 'dark' ? theme.dark.mainBackground : theme.light.mainBackground};
    width: 100%;
    min-height: 100vh;
    /* display: flex;
    flex-direction: column; */
    max-width: 1750px;
    margin: 0 auto;

    //display: grid;
    //grid-template-areas:
    //    'header header header'
    //    'menu main main'
    //    'footer footer footer';
    //grid-template-columns: auto 1fr;
    //grid-template-rows: auto 1fr 4rem;
    gap: 10px;
    padding: 10px;

    .header {
        grid-area: header;
        z-index: 100;
        top: 0;
    }

    .menu {
        grid-area: menu;
        padding-top: 4rem;
    }

    .main {
        ${colorFromTheme};
        grid-area: main;
        padding-top: 3.5rem;
        width: 100%;
    }

    .footer {
        grid-area: footer;
    }

    @media(max-width: 750px) {
        padding: 0 15px;
    }
`;

export const Wrapper = styled.div`
    background-color: ${({ theme }) => theme.mode === 'dark' ? theme.dark.mainBackground : theme.light.mainBackground};
    min-height: 100vh;
`;